import { ProfileSubscriptionBase } from '../../../../../models/profile-subsription';
import { boschEmailValidator, mustNotBeBlankValidator } from '../../../../../../common/utils/validators';
import { DayOfWeek } from '../../../../../../common/constants/day-of-week';
import { SchedulingType } from '../../../../../../common/constants/scheduling-type';
import { FailedMessagesProfileReportModel } from './failed-messages-profile-report.model';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { FailedMessagesFilterModel } from '../filters/failed-messages-filter.model';
import { PlannerProfileType } from '../../../../../constants';

export class FailedMessagesPartnerModel {
  extId: string | null = null;
  id: number | null = null;
  name: string | null = null;

  constructor(params?: FailedMessagesPartnerModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FailedMessagesProfileSubscription extends ProfileSubscriptionBase {
  emails: string[] = [];
  partner: FailedMessagesPartnerModel | null = null;

  constructor(params?: FailedMessagesProfileSubscription) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FailedMessagesProfileItemModel {
  id: number | null = null;
  createdBy: number | null = null;
  createdByEmail: string | null = null;
  createdAt = 0;
  name: string | null = null;
  description: string | null = null;
  type: PlannerProfileType = PlannerProfileType.Public;
  subscription: FailedMessagesProfileSubscription | null = null;
  report: FailedMessagesProfileReportModel | null = null;

  constructor(params?: FailedMessagesProfileItemModel) {
    if (params) {
      Object.assign(this, params);
      if (!params.subscription) {
        this.subscription = new FailedMessagesProfileSubscription();
      }
      if (!params.report) {
        this.report = new FailedMessagesProfileReportModel();
      }
    }
  }
}

export class FailedMessagesProfileItemFilterModel extends FailedMessagesProfileItemModel {
  filter: FailedMessagesFilterModel = new FailedMessagesFilterModel();

  constructor(params?: FailedMessagesProfileItemFilterModel) {
    super();
    if (params) {
      Object.assign(this, params);
      this.filter = new FailedMessagesFilterModel(params.filter);
    }
  }
}

export class FailedMessagesProfileSubscriptionForm {
  constructor(
    model: FailedMessagesProfileSubscription,
    fb: FormBuilder = new FormBuilder(),
    public id: FormControl<number> = fb.control<number>(model.id, []),
    public hours: FormControl<number[]> = fb.control<number[]>(model.hours, [
      Validators.required,
      Validators.minLength(1),
    ]),
    public schedulingType: FormControl<SchedulingType> = fb.control<SchedulingType>(model.schedulingType, [
      Validators.required,
    ]),
    public day: FormControl<DayOfWeek> = fb.control<DayOfWeek>(model.day, []),
    public emails: FormControl<string[]> = fb.control<string[]>(model.emails, [boschEmailValidator]),
    public partner: FormControl<FailedMessagesPartnerModel | null> = fb.control<FailedMessagesPartnerModel>(
      model.partner,
    ),
  ) {}
}

export class FailedMessagesPlannerProfileItemForm {
  constructor(
    model: FailedMessagesProfileItemModel,
    fb: FormBuilder = new FormBuilder(),
    public id: FormControl<number> = fb.control<number>(model.id ?? null, []),
    public createdBy: FormControl<number> = fb.control<number>(model.createdBy ?? null, []),
    public createdByEmail: FormControl<string> = fb.control<string>(model.createdByEmail ?? null, []),
    public createdAt: FormControl<number> = fb.control<number>(model.createdAt ?? null, []),
    public name: FormControl<string> = fb.control<string>(model.name, [Validators.required, mustNotBeBlankValidator]),
    public description: FormControl<string> = fb.control<string>(model.description, []),
    public type: FormControl<PlannerProfileType> = fb.control<PlannerProfileType>(model.type, []),
    public subscription: FormControl<FailedMessagesProfileSubscription | null> = fb.control<FailedMessagesProfileSubscription | null>(
      model.subscription ? new FailedMessagesProfileSubscription(model.subscription) : null,
    ),
    public report: FormControl<FailedMessagesProfileReportModel | null> = fb.control<FailedMessagesProfileReportModel | null>(
      model.report ? new FailedMessagesProfileReportModel(model.report) : null,
    ),
  ) {}
}

export class FailedMessagesPlannerProfileItemFiltersForm {
  constructor(
    model: FailedMessagesProfileItemFilterModel,
    fb: FormBuilder = new FormBuilder(),
    public id: FormControl<number> = fb.control<number>(model.id ?? null, []),
    public createdBy: FormControl<number> = fb.control<number>(model.createdBy ?? null, []),
    public createdByEmail: FormControl<string> = fb.control<string>(model.createdByEmail ?? null, []),
    public createdAt: FormControl<number> = fb.control<number>(model.createdAt ?? null, []),
    public name: FormControl<string> = fb.control<string>(model.name, [Validators.required, mustNotBeBlankValidator]),
    public description: FormControl<string> = fb.control<string>(model.description, []),
    public type: FormControl<PlannerProfileType> = fb.control<PlannerProfileType>(model.type, []),
    public filter: FormControl<FailedMessagesFilterModel> = fb.control<FailedMessagesFilterModel>(model.filter, []),
    public subscription: FormControl<FailedMessagesProfileSubscription | null> = fb.control<FailedMessagesProfileSubscription | null>(
      model.subscription ? new FailedMessagesProfileSubscription(model.subscription) : null,
    ),
    public report: FormControl<FailedMessagesProfileReportModel | null> = fb.control<FailedMessagesProfileReportModel | null>(
      model.report ? new FailedMessagesProfileReportModel(model.report) : null,
    ),
  ) {}
}
